import { NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '@/store/auth'
import { toastError } from '@/store/toast'

export default function AppShell({ children }: { children: React.ReactNode }) {
  const user = useAuth((s) => s.user)
  const logout = useAuth((s) => s.logout)
  const navigate = useNavigate()

  const today = new Date().toLocaleDateString('th-TH', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })

  async function handleLogout() {
    try {
      await logout()
      navigate('/login', { replace: true })
    } catch (e) {
      toastError('ออกจากระบบไม่สำเร็จ')
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  return (
    <div className="min-h-full flex flex-col">
      <header className="bg-brand-700 text-white shadow no-print pt-[env(safe-area-inset-top)]">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between gap-3">
          <div className="flex items-center gap-4">
            <h1 className="text-xl font-bold">Work Evolution</h1>
            <nav className="flex gap-1 text-sm">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md ${
                    isActive ? 'bg-white/20' : 'hover:bg-white/10'
                  }`
                }
                end
              >
                POS
              </NavLink>
              <NavLink
                to="/receipts"
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md ${
                    isActive ? 'bg-white/20' : 'hover:bg-white/10'
                  }`
                }
              >
                ประวัติใบเสร็จ
              </NavLink>
              <NavLink
                to="/patients"
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md ${
                    isActive ? 'bg-white/20' : 'hover:bg-white/10'
                  }`
                }
              >
                คนไข้
              </NavLink>
              <NavLink
                to="/visits"
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md ${
                    isActive ? 'bg-white/20' : 'hover:bg-white/10'
                  }`
                }
              >
                เข้ารับการรักษา
              </NavLink>
              <NavLink
                to="/calendar"
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md ${
                    isActive ? 'bg-white/20' : 'hover:bg-white/10'
                  }`
                }
              >
                ปฏิทินนัด
              </NavLink>
              <NavLink
                to="/products"
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md ${
                    isActive ? 'bg-white/20' : 'hover:bg-white/10'
                  }`
                }
              >
                สินค้า/บริการ
              </NavLink>
            </nav>
          </div>
          <div className="flex items-center gap-3 text-sm">
            <span className="opacity-90">📅 {today}</span>
            <span className="opacity-90">👤 {user?.username ?? '-'}</span>
            <button
              onClick={handleLogout}
              className="px-3 py-2 rounded-md bg-white/10 hover:bg-white/20"
            >
              ออกจากระบบ
            </button>
          </div>
        </div>
      </header>
      <main className="flex-1 pb-[env(safe-area-inset-bottom)]">{children}</main>
    </div>
  )
}
